import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const useStyles = makeStyles((theme) => ({
  pipCoverageCard: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    borderRadius: theme.sizes.roundCorners,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24
  },
  pipMEContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: theme.spacing(-4)
  },
  separator: {
    width: '100%',
    borderBottom: `1px solid ${theme.onCardDivider.green_75}`,
    margin: theme.spacing(-2, 0, -1)
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(-2)
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  pipEligibilityText: {
    color: theme.colorPalette.beige_75,
    fontSize: 11,
    fontStyle: 'italic',
    fontWeight: 400,
    marginLeft: theme.spacing(-2),
    ...reskinStyles(theme, { color: theme.colors.text_secondary })
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  warningContainer: {
    backgroundColor: theme.colorPalette.green_90,
    padding: '8px 0px 8px 40px',
    marginTop: theme.spacing(-2),
    color: theme.onCard.white,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  infoCard: {
    width: 616,
    gap: 8,
    backgroundColor: theme.colorPalette.green_100,
    padding: '16px 16px 8px',
    marginBottom: 8,
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  iconSmall: {
    height: 16,
    marginTop: 6
  },
  iconAllOptOut: {
    height: 16,
    marginTop: 16
  },
  notificationContentWithTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.onCard.white,
    marginTop: -10
  },
  titleText: {
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 4
  }
}));

export default useStyles;
